import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'

import { popupChange } from '../../actions/index'

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

class CloseButton extends React.Component {
    handleCloseChange = () => {
        this.props.popupChange('none')
    };

    render() {
        return(
            <div>
                <div className="close-button-layout">
                    <IconButton className='close-button p-0' variant="contained" onClick={this.handleCloseChange}>
                        <CloseIcon fontSize='large'/>
                    </IconButton>
                </div>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return {}
}


function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        popupChange    : popupChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(CloseButton);